import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import { BusinessSMSMonitorPage } from '../lazyPages';

export const BusinessSMSMonitorRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('BUSINESS_SIDEBAR.QR_MONITOR')}>
            <BusinessSMSMonitorPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
